import { RouteRecordRaw } from "vue-router";

const mfRoutes: RouteRecordRaw[] = [
  {
    path: "/devtest/new-math-test/:levelId",
    component: () => import("../views/devtest/NewMathTestView.vue"),
  },
];

export default mfRoutes;
